import axios from "axios";

export default axios.create({
  baseURL: "https://api.southteams.io/",
  responseType: "json",
  headers: {
    Authorization: window.localStorage.getItem("token"),
  },
});
